import { render, staticRenderFns } from "./InteractionsView.vue?vue&type=template&id=2c443d92&scoped=true&"
import script from "./InteractionsView.vue?vue&type=script&lang=js&"
export * from "./InteractionsView.vue?vue&type=script&lang=js&"
import style0 from "./InteractionsView.vue?vue&type=style&index=0&id=2c443d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c443d92",
  null
  
)

export default component.exports